<template>
	<canvas class="background" id="canvas"></canvas>
</template>

<script>
	import main from './bg.js'
	
	export default {
		mounted() {
			main();
		}
	}
</script>

<style lang="stylus" scoped>
	.background {
		position: absolute;
		width: 100vw;
		height: 100vh;
		opacity: 0.6;
	}
</style>